import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GtmService } from '@shared/services/gtm.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
  standalone: true,
})
export class AppComponent {
  constructor(private readonly gtmService: GtmService) { }
}
